const ACTIVE_INTERVAL_MS = 5_000;
const RECOVERY_INTERVAL_MS = 15_000;

export const PROCESSING_RETRY = 1;

export const processingRefetchInterval = (query: {
	state: {
		data: { active: boolean } | null | undefined;
		status: "error" | "pending" | "success";
	};
}) => {
	if (query.state.status === "error") {
		return RECOVERY_INTERVAL_MS;
	}
	return query.state.data?.active ? ACTIVE_INTERVAL_MS : false;
};
